/**
 * @param {Object} str
 */
export function phoneMapping (str) {
  return phoneDict[str]
}

export const phoneDict = {
  一: ['yi1', 'yi4', 'yi2'],
  丁: ['ding1', 'zheng1'],
  万: ['wan4', 'mo4'],
  与: ['yu3', 'yu2', 'yu4'],
  且: ['qie3', 'ju1'],
  丧: ['sang1', 'sang4'],
  个: ['ge5', 'ge3', 'ge4'],
  中: ['zhong1', 'zhong4'],
  为: ['wei2', 'wei4'],
  丽: ['li4', 'li2'],
  么: ['me5', 'ma5', 'mo2', 'yao1'],
  乐: ['le4', 'yue4'],
  乘: ['cheng2', 'sheng4'],
  乜: ['mie1', 'nie4'],
  乾: ['qian2', 'gan1'],
  了: ['le5', 'liao3', 'liao4'],
  予: ['yu3', 'yu2'],
  于: ['yu2', 'yu1', 'wu1'],
  亟: ['ji2', 'qi4'],
  亲: ['qin1', 'qing4'],
  什: ['shen2', 'shi2'],
  仅: ['jin3', 'jin4'],
  仆: ['pu2', 'pu1'],
  仇: ['chou2', 'qiu2'],
  仔: ['zai3', 'zi1', 'zi3'],
  仡: ['ge1', 'yi4'],
  令: ['ling4', 'ling3'],
  任: ['ren4', 'ren2'],
  会: ['hui4', 'kuai4'],
  传: ['zhuan4', 'chuan2'],
  伧: ['cang1', 'chen5'],
  伯: ['bo2', 'bai3'],
  估: ['gu1', 'gu4'],
  伺: ['si4', 'ci4'],
  似: ['shi4', 'si4'],
  伽: ['ga1', 'jia1', 'qie2'],
  佃: ['dian4', 'tian2'],
  体: ['ti3', 'ti1'],
  佛: ['fo2', 'fu2'],
  作: ['zuo1', 'zuo4'],
  佣: ['yong1', 'yong4'],
  佴: ['er4', 'nai4'],
  侗: ['dong4', 'tong2', 'tong3'],
  供: ['gong4', 'gong1'],
  侧: ['ce4', 'ze4', 'zhai1'],
  侯: ['hou2', 'hou4'],
  便: ['bian4', 'pian2'],
  俛: ['mian3', 'fu3'],
  俞: ['yu2', 'shu4'],
  俟: ['qi2', 'si4'],
  俩: ['lia3', 'liang3'],
  倒: ['dao3', 'dao4'],
  倔: ['jue4', 'jue2'],
  倘: ['tang3', 'chang2'],
  倥: ['kong1', 'kong3'],
  假: ['jia3', 'jia4'],
  偈: ['ji4', 'jie2'],
  偻: ['lou2', 'lv3'],
  僮: ['tong2', 'zhuang4'],
  儿: ['er2', 'er5'],
  兀: ['wu1', 'wu4'],
  六: ['liu4', 'lu4'],
  兴: ['xing1', 'xing4'],
  兹: ['zi1', 'ci2'],
  冒: ['mao4', 'mo4'],
  冠: ['guan4', 'guan1'],
  冯: ['feng2', 'ping2'],
  冲: ['chong1', 'chong4'],
  凉: ['liang2', 'liang4'],
  几: ['ji3', 'ji1'],
  分: ['fen1', 'fen4'],
  切: ['qie1', 'qie4'],
  划: ['hua2', 'hua4'],
  创: ['chuang4', 'chuang1'],
  刨: ['bao4', 'pao2'],
  别: ['bie2', 'bie4'],
  刷: ['shua1', 'shua4'],
  券: ['quan4', 'xuan4'],
  刹: ['cha4', 'sha1'],
  刺: ['ci4', 'ci1'],
  削: ['xiao1', 'xue1'],
  剡: ['shan4', 'yan3'],
  剥: ['bao1', 'bo1'],
  剿: ['chao1', 'jiao3'],
  劈: ['pi1', 'pi3'],
  劲: ['jin4', 'jing4'],
  勒: ['le4', 'lei1'],
  勾: ['gou1', 'gou4'],
  化: ['hua4', 'hua1'],
  匙: ['chi2', 'shi5'],
  区: ['qu1', 'ou1'],
  华: ['hua2', 'hua4'],
  卒: ['zu2', 'cu4'],
  单: ['dan1', 'chan2', 'shan4'],
  卜: ['bo5', 'bu3'],
  占: ['zhan4', 'zhan1'],
  卡: ['ka3', 'qia3'],
  卷: ['juan3', 'juan4'],
  压: ['ya1', 'ya4'],
  厦: ['sha4', 'xia4'],
  参: ['can1', 'cen1', 'shen1'],
  叉: ['cha1', 'cha2', 'cha3', 'cha4'],
  发: ['fa1', 'fa4'],
  句: ['ju4', 'gou1'],
  叨: ['dao1', 'dao2', 'tao1'],
  只: ['zhi1', 'zhi3'],
  召: ['zhao4', 'shao4'],
  可: ['ke3', 'ke4'],
  台: ['tai2', 'tai1'],
  叶: ['ye4', 'xie2'],
  号: ['hao4', 'hao2'],
  吁: ['xu1', 'yu1', 'yu4'],
  各: ['ge4', 'ge3'],
  同: ['tong2', 'tong4'],
  吐: ['tu3', 'tu4'],
  吓: ['xia4', 'he4'],
  吗: ['ma5', 'ma2', 'ma3'],
  吡: ['bi3', 'pi3'],
  否: ['fou3', 'pi3'],
  吧: ['ba5', 'ba1'],
  吭: ['keng1', 'hang2'],
  吱: ['zhi1', 'zi1'],
  吵: ['chao3', 'chao1'],
  呀: ['ya5', 'ya1'],
  呆: ['dai1', 'ai2'],
  呐: ['na5', 'na4', 'ne4'],
  呔: ['dai1', 'tai3'],
  呕: ['ou3', 'ou4'],
  呗: ['bei5', 'bai4'],
  员: ['yuan2', 'yun2', 'yun4'],
  呛: ['qiang1', 'qiang4'],
  呢: ['ne5', 'ni2'],
  呱: ['gua1', 'gu1', 'gua3'],
  呲: ['ci1', 'zi1'],
  呷: ['xia1', 'ga1'],
  咀: ['ju3', 'zui3'],
  咋: ['za3', 'ze2', 'zha1'],
  和: ['he2', 'he4', 'hu2', 'huo2', 'huo4'],
  咔: ['ka1', 'ka3'],
  咖: ['ka1', 'ga1'],
  咧: ['lie1', 'lie3', 'lie5'],
  咯: ['lo5', 'ge1', 'ka3'],
  咱: ['zan2', 'za2', 'zan5'],
  咳: ['ke2', 'hai1'],
  咽: ['yan1', 'yan4', 'ye4'],
  哄: ['hong3', 'hong1', 'hong4'],
  哇: ['wa5', 'wa1'],
  哈: ['ha1', 'ha3', 'ha4'],
  哎: ['ai1', 'ai3', 'ai4'],
  哑: ['ya3', 'ya1'],
  哕: ['yue3', 'hui4'],
  哗: ['hua1', 'hua2'],
  哟: ['yo5', 'yo1'],
  哩: ['li5', 'li1', 'li3'],
  哪: ['na3', 'na5', 'ne2', 'nei3'],
  哼: ['heng1', 'heng5'],
  唉: ['ai4', 'ai1'],
  唠: ['lao4', 'lao2'],
  啁: ['zhao1', 'zhou1'],
  啜: ['chuai4', 'chuo4'],
  啦: ['la5', 'la1'],
  啵: ['bo1', 'bo5'],
  喁: ['yong2', 'yu2'],
  喋: ['die2', 'zha2'],
  喏: ['nuo4', 're3'],
  喔: ['wo5', 'wo1'],
  喝: ['he1', 'he4'],
  喳: ['zha1', 'cha1'],
  喷: ['pen1', 'pen4'],
  喽: ['lou5', 'lou2'],
  嗄: ['a2', 'sha4'],
  嗌: ['ai4', 'yi4'],
  嗑: ['ke1', 'ke4'],
  嗒: ['da1', 'ta4'],
  嗳: ['ai3', 'ai4'],
  嗻: ['zhe1', 'zhe4'],
  嘀: ['di1', 'di2'],
  嘎: ['ga1', 'ga2', 'ga3'],
  嘏: ['gu3', 'jia3'],
  嘘: ['xu1', 'shi1'],
  嘚: ['de1', 'dei1'],
  嘞: ['lei5', 'le1'],
  嘬: ['zuo1', 'chuai4'],
  嘲: ['chao2', 'zhao1'],
  嘿: ['hei1', 'mo4'],
  噌: ['ceng1', 'cheng1'],
  噱: ['xue2', 'jue2'],
  嚓: ['ca1', 'cha1'],
  嚷: ['rang1', 'rang3'],
  嚼: ['jiao2', 'jiao4', 'jue2'],
  囊: ['nang2', 'nang1'],
  囤: ['tun2', 'dun4'],
  圈: ['quan1', 'juan4', 'juan1'],
  圜: ['huan2', 'yuan2'],
  圩: ['wei2', 'xu1'],
  地: ['di4', 'de5'],
  场: ['chang3', 'chang2'],
  圻: ['qi2', 'yin2'],
  坊: ['fang1', 'fang2'],
  坏: ['huai4', 'pi1'],
  坷: ['ke1', 'ke3'],
  坻: ['di3', 'chi2'],
  垌: ['dong4', 'tong2'],
  垛: ['duo3', 'duo4'],
  埋: ['mai2', 'man2'],
  埔: ['bu4', 'pu3'],
  埤: ['pi2', 'pi4'],
  堆: ['dui1', 'zui1'],
  堡: ['bao3', 'bu3', 'pu4'],
  塞: ['sai1', 'sai4', 'se4'],
  壳: ['ke2', 'qiao4'],
  处: ['chu3', 'chu4'],
  大: ['da4', 'dai4'],
  夫: ['fu1', 'fu2'],
  夯: ['hang1', 'ben4'],
  夹: ['jia1', 'ga1', 'jia2'],
  奇: ['ji1', 'qi2'],
  契: ['qi4', 'xie4'],
  奓: ['zha4', 'she1'],
  奔: ['ben1', 'ben4'],
  奘: ['zang4', 'zhuang3'],
  好: ['hao3', 'hao4'],
  妻: ['qi1', 'qi4'],
  委: ['wei3', 'wei1'],
  姥: ['lao3', 'mu3'],
  娆: ['rao2', 'rao3'],
  娜: ['na4', 'nuo2'],
  婼: ['chuo4', 'ruo4'],
  媛: ['yuan2', 'yuan4'],
  孛: ['bei4', 'bo2'],
  孱: ['can4', 'chan2'],
  宁: ['ning2', 'ning4'],
  宿: ['su4', 'xiu3', 'xiu4'],
  将: ['jiang1', 'jiang4'],
  尉: ['wei4', 'yu4'],
  少: ['shao3', 'shao4'],
  尺: ['chi3', 'che3'],
  尽: ['jin4', 'jin3'],
  尾: ['wei3', 'yi3'],
  尿: ['niao4', 'sui1'],
  屏: ['bing3', 'ping2'],
  属: ['shu3', 'zhu3'],
  屯: ['tun2', 'zhun1'],
  峒: ['dong4', 'tong2'],
  峙: ['shi4', 'zhi4'],
  峤: ['jiao4', 'qiao2'],
  崴: ['wai3', 'wei1'],
  差: ['cha4', 'cha1', 'chai1', 'ci1'],
  巷: ['xiang4', 'hang4'],
  帖: ['tie3', 'tie1', 'tie4'],
  帱: ['chou2', 'dao4'],
  幢: ['zhuang4', 'chuang2'],
  干: ['gan1', 'gan4'],
  并: ['bing4', 'bing1'],
  应: ['ying1', 'ying4'],
  度: ['du4', 'duo2'],
  廑: ['jin3', 'qin2'],
  弄: ['nong4', 'long4'],
  弹: ['dan4', 'tan2'],
  强: ['qiang2', 'jiang4', 'qiang3'],
  当: ['dang1', 'dang4'],
  彷: ['fang3', 'pang2'],
  待: ['dai1', 'dai4'],
  徕: ['lai2', 'lai4'],
  得: ['de2', 'de5', 'dei3'],
  徵: ['zheng1', 'zhi3'],
  徼: ['jiao3', 'jiao4'],
  忒: ['tui1', 'tei1', 'te4'],
  忪: ['song1', 'zhong1'],
  怂: ['song2', 'song3'],
  怼: ['dui3', 'dui4'],
  恫: ['dong4', 'tong1'],
  恶: ['e4', 'e3', 'wu1', 'wu4'],
  悄: ['qiao1', 'qiao3'],
  悝: ['kui1', 'li3'],
  惝: ['chang3', 'tang3'],
  慊: ['qian4', 'qie4'],
  戆: ['gang4', 'zhuang4'],
  戏: ['xi4', 'hu1'],
  戗: ['qiang4', 'qiang1'],
  扁: ['bian3', 'pian1'],
  扇: ['shan1', 'shan4'],
  扎: ['zha1', 'za1', 'zha2'],
  扒: ['ba1', 'pa2'],
  打: ['da3', 'da2'],
  扛: ['kang2', 'gang1'],
  扫: ['sao3', 'sao4'],
  把: ['ba3', 'ba4'],
  折: ['zhe2', 'she2', 'zhe1'],
  抡: ['lun1', 'lun2'],
  抢: ['qiang3', 'qiang1'],
  抹: ['mo3', 'ma1', 'mo4'],
  担: ['dan1', 'dan4'],
  拆: ['chai1', 'ca1'],
  拉: ['la1', 'la2', 'la3', 'la4'],
  拓: ['ta4', 'tuo4'],
  拗: ['ao3', 'ao4', 'niu4'],
  拚: ['pin1', 'pan4'],
  拧: ['ning2', 'ning3', 'ning4'],
  择: ['ze2', 'zhai2'],
  括: ['kuo4', 'gua1'],
  拶: ['za1', 'zan3'],
  拽: ['zhuai4', 'zhuai1'],
  挑: ['tiao1', 'tiao3'],
  挝: ['wo1', 'zhua1'],
  挟: ['xie2', 'jia1'],
  挡: ['dang3', 'dang4'],
  挣: ['zheng1', 'zheng4'],
  挨: ['ai1', 'ai2'],
  挲: ['sa1', 'sha1', 'suo1'],
  捋: ['lv3', 'luo1'],
  捎: ['shao1', 'shao4'],
  据: ['ju4', 'ju1'],
  掊: ['pou2', 'pou3'],
  排: ['pai2', 'pai3'],
  掖: ['ye1', 'ye4'],
  掴: ['guo2', 'guai1'],
  掸: ['dan3', 'shan4'],
  提: ['ti2', 'di1'],
  揣: ['chuai1', 'chuai3', 'chuai4'],
  揲: ['die2', 'she2'],
  搁: ['ge1', 'ge2'],
  搂: ['lou1', 'lou3'],
  摩: ['ma1', 'mo2'],
  撇: ['pie1', 'pie3'],
  撒: ['sa3', 'sa1'],
  撩: ['liao1', 'liao2'],
  撮: ['cuo1', 'zuo3'],
  擂: ['lei2', 'lei1', 'lei4'],
  擞: ['sou3', 'sou4'],
  攒: ['cuan2', 'zan3'],
  教: ['jiao1', 'jiao4'],
  散: ['san3', 'san4'],
  敦: ['dun1', 'dui4'],
  数: ['shu3', 'shu4', 'shuo4'],
  斗: ['dou3', 'dou4'],
  於: ['yu1', 'wu1'],
  旋: ['xuan2', 'xuan4'],
  晃: ['huang3', 'huang4'],
  晕: ['yun1', 'yun4'],
  晟: ['sheng4', 'cheng2'],
  暴: ['bao4', 'pu4'],
  曝: ['bao4', 'pu4'],
  曲: ['qu1', 'qu3'],
  更: ['geng1', 'geng4'],
  曾: ['ceng2', 'zeng1'],
  服: ['fu2', 'fu4'],
  朝: ['chao2', 'zhao1'],
  期: ['qi1', 'ji1'],
  术: ['shu4', 'zhu2'],
  朴: ['piao2', 'po1', 'po4', 'pu3'],
  杆: ['gan1', 'gan3'],
  杈: ['cha1', 'cha4'],
  杉: ['shan1', 'sha1'],
  杻: ['chou3', 'niu3'],
  枞: ['cong1', 'zong1'],
  枸: ['gou3', 'gou1', 'ju3'],
  柏: ['bai3', 'bo2', 'bo4'],
  柚: ['you4', 'you2'],
  柜: ['gui4', 'ju3'],
  柞: ['zha4', 'zuo4'],
  查: ['cha2', 'zha1'],
  栅: ['shan1', 'zha4'],
  栎: ['li4', 'yue4'],
  栖: ['qi1', 'xi1'],
  栝: ['gua1', 'kuo4'],
  校: ['xiao4', 'jiao4'],
  核: ['he2', 'hu2'],
  桄: ['guang1', 'guang4'],
  框: ['kuang1', 'kuang4'],
  桔: ['ju2', 'jie2'],
  桧: ['hui4', 'gui4'],
  梃: ['ting3', 'ting4'],
  棱: ['leng2', 'ling2'],
  椎: ['chui2', 'zhui1'],
  椹: ['shen4', 'zhen1'],
  楂: ['cha2', 'zha1'],
  楷: ['jie1', 'kai3'],
  槛: ['jian4', 'kan3'],
  槟: ['bin1', 'bing1'],
  模: ['mo2', 'mu2'],
  横: ['heng2', 'heng4'],
  欸: ['ei1', 'ei2', 'ei4', 'ei3'],
  欹: ['qi1', 'yi1'],
  歙: ['she4', 'xi1'],
  正: ['zheng1', 'zheng4'],
  殖: ['zhi2', 'shi5'],
  殷: ['yin1', 'yan1', 'yin3'],
  毂: ['gu3', 'gu1'],
  氏: ['shi4', 'zhi1'],
  氐: ['di3', 'di1'],
  氓: ['mang2', 'meng2'],
  汗: ['han4', 'han2'],
  沈: ['shen3', 'chen2'],
  沉: ['chen2', 'shen3'],
  沌: ['dun4', 'zhuan4'],
  沓: ['da2', 'ta4'],
  没: ['mei2', 'mo4'],
  沤: ['ou1', 'ou4'],
  沮: ['ju3', 'ju4'],
  沲: ['duo4', 'tuo2'],
  泊: ['bo2', 'po1'],
  泌: ['bi4', 'mi4'],
  泡: ['pao1', 'pao4'],
  泥: ['ni2', 'ni4'],
  泷: ['long2', 'shuang1'],
  洗: ['xi3', 'xian3'],
  浅: ['qian3', 'jian1'],
  浆: ['jiang1', 'jiang4'],
  浍: ['hui4', 'kuai4'],
  济: ['ji3', 'ji4'],
  浒: ['hu3', 'xu3'],
  浚: ['jun4', 'xun4'],
  涡: ['wo1', 'guo1'],
  涨: ['zhang3', 'zhang4'],
  淋: ['lin2', 'lin4'],
  混: ['hun2', 'hun4'],
  渐: ['jian4', 'jian1'],
  渑: ['mian3', 'sheng2'],
  湫: ['qiu1', 'jiao3'],
  溜: ['liu1', 'liu4'],
  溱: ['qin2', 'zhen1'],
  溺: ['ni4', 'niao4'],
  漂: ['piao1', 'piao3', 'piao4'],
  漯: ['luo4', 'ta4'],
  潦: ['liao2', 'lao3'],
  澄: ['cheng2', 'deng4'],
  澎: ['peng2', 'peng1'],
  澹: ['dan4', 'tan2'],
  瀑: ['pu4', 'bao4'],
  炅: ['jiong3', 'gui4'],
  炮: ['pao2', 'bao1', 'pao4'],
  炸: ['zha2', 'zha4'],
  烊: ['yang2', 'yang4'],
  烙: ['lao4', 'luo4'],
  焘: ['tao1', 'dao4'],
  焯: ['chao1', 'zhuo1'],
  煞: ['sha4', 'sha1'],
  熏: ['xun1', 'xun4'],
  熟: ['shou2', 'shu2'],
  熨: ['yun4', 'yu4'],
  熬: ['ao2', 'ao1'],
  燎: ['liao2', 'liao3'],
  燕: ['yan1', 'yan4'],
  爪: ['zhao3', 'zhua3'],
  父: ['fu4', 'fu3'],
  片: ['pian4', 'pian1'],
  牟: ['mou2', 'mu4'],
  犍: ['jian1', 'qian2'],
  猫: ['mao1', 'mao2'],
  率: ['lv4', 'shuai4'],
  王: ['wang2', 'wang4'],
  玟: ['wen2', 'min2'],
  玢: ['bin1', 'fen1'],
  珲: ['hui1', 'hun2'],
  琶: ['pa2', 'pa5'],
  璃: ['li2', 'li5'],
  瓦: ['wa3', 'wa4'],
  甚: ['shen4', 'shen2'],
  甯: ['ning2', 'ning4'],
  町: ['ding1', 'ting3'],
  畜: ['chu4', 'xu4'],
  番: ['fan1', 'pan1'],
  疟: ['nve4', 'yao4'],
  疸: ['dan3', 'da5'],
  症: ['zheng4', 'zheng1'],
  瘅: ['dan1', 'dan4'],
  瘛: ['chi4', 'zhi4'],
  瘥: ['chai4', 'cuo2'],
  瘩: ['da2', 'da5'],
  瘪: ['bie3', 'bie1'],
  癞: ['lai4', 'la4'],
  百: ['bai3', 'bo2'],
  的: ['de5', 'di2', 'di4'],
  监: ['jian1', 'jian4'],
  盖: ['gai4', 'ge3'],
  盛: ['cheng2', 'sheng4'],
  相: ['xiang1', 'xiang4'],
  省: ['sheng3', 'xing3'],
  眄: ['mian3', 'mian4'],
  看: ['kan1', 'kan4'],
  眙: ['yi2', 'chi4'],
  眯: ['mi1', 'mi2'],
  着: ['zhe5', 'zhao1', 'zhao2', 'zhuo2'],
  瞇: ['mi1', 'mi2'],
  瞿: ['qu2', 'ju4'],
  矜: ['jin1', 'guan1', 'qin2'],
  矫: ['jiao3', 'jiao2'],
  石: ['shi2', 'dan4'],
  砉: ['hua1', 'xu1'],
  砌: ['qi4', 'qie4'],
  研: ['yan2', 'yan4'],
  硌: ['ge4', 'luo4'],
  碌: ['lu4', 'liu4'],
  碴: ['cha2', 'cha1'],
  磅: ['bang4', 'pang2'],
  磨: ['mo2', 'mo4'],
  禁: ['jin4', 'jin1'],
  禅: ['chan2', 'shan4'],
  种: ['zhong3', 'zhong4', 'chong2'],
  秘: ['mi4', 'bi4'],
  秤: ['cheng4', 'cheng1', 'chen4'],
  称: ['cheng1', 'chen4', 'cheng4'],
  稍: ['shao1', 'shao4'],
  稽: ['ji1', 'qi3'],
  空: ['kong1', 'kong4'],
  窨: ['xun1', 'yin4'],
  笮: ['ze2', 'zuo2'],
  笼: ['long2', 'long3'],
  答: ['da2', 'da1'],
  筠: ['jun1', 'yun2'],
  簸: ['bo3', 'bo4'],
  粘: ['nian2', 'zhan1'],
  粢: ['ci1', 'zi1'],
  粥: ['zhou1', 'yu4'],
  糁: ['san3', 'shen1'],
  糊: ['hu1', 'hu2', 'hu4'],
  糜: ['mi2', 'mei2'],
  糸: ['mi4', 'si1'],
  系: ['ji4', 'xi4'],
  累: ['lei4', 'lei2', 'lei3'],
  綮: ['qi3', 'qing4'],
  繁: ['fan2', 'po2'],
  繇: ['yao2', 'you2', 'zhou4'],
  红: ['hong2', 'gong1'],
  纤: ['xian1', 'qian4'],
  纥: ['ge1', 'he2'],
  约: ['yue1', 'yao1'],
  纪: ['ji4', 'ji3'],
  纶: ['guan1', 'lun2'],
  纹: ['wen2', 'wen4'],
  绉: ['zhou4', 'zhou1'],
  结: ['jie2', 'jie1'],
  给: ['gei3', 'ji3'],
  络: ['luo4', 'lao4'],
  绨: ['ti2', 'ti4'],
  绩: ['ji4', 'ji1'],
  绰: ['chuo4', 'chao1'],
  绷: ['beng1', 'beng3'],
  综: ['zong1', 'zeng4'],
  绿: ['lv4', 'lu4'],
  缉: ['ji1', 'qi1'],
  缏: ['bian4', 'pian2'],
  缝: ['feng2', 'feng4'],
  缥: ['piao1', 'piao3'],
  缩: ['suo1', 'su4'],
  缪: ['miao4', 'miu4', 'mou2'],
  缯: ['zeng1', 'zeng4'],
  缴: ['jiao3', 'zhuo2'],
  罗: ['luo2', 'luo1'],
  罢: ['ba4', 'ba5'],
  翘: ['qiao4', 'qiao2'],
  翟: ['zhai2', 'di2'],
  耙: ['pa2', 'ba4'],
  耶: ['ye1', 'ye2'],
  肋: ['lei4', 'le1'],
  肖: ['xiao1', 'xiao4'],
  肚: ['du3', 'du4'],
  背: ['bei1', 'bei4'],
  胖: ['pang4', 'pan2'],
  胜: ['sheng4', 'sheng1'],
  胲: ['gai3', 'hai3'],
  胳: ['ge1', 'ge2'],
  脉: ['mai4', 'mo4'],
  脊: ['ji2', 'ji3'],
  脏: ['zang1', 'zang4'],
  脚: ['jiao3', 'jue2'],
  脯: ['fu3', 'pu2'],
  腊: ['la4', 'xi1'],
  腌: ['a1', 'yan1'],
  膀: ['bang3', 'pang1', 'pang2'],
  膈: ['ge2', 'ge4'],
  膏: ['gao1', 'gao4'],
  臂: ['bei5', 'bi4'],
  臊: ['sao1', 'sao4'],
  臭: ['chou4', 'xiu4'],
  舍: ['she3', 'she4'],
  色: ['se4', 'shai3'],
  节: ['jie2', 'jie1'],
  芥: ['gai4', 'jie4'],
  芫: ['yan2', 'yuan2'],
  芯: ['xin1', 'xin4'],
  芾: ['fei4', 'fu2'],
  苔: ['tai1', 'tai2'],
  苕: ['shao2', 'tiao2'],
  苣: ['ju4', 'qu3'],
  苫: ['shan1', 'shan4'],
  苹: ['pin2', 'ping2'],
  茄: ['jia1', 'qie2'],
  茈: ['ci2', 'zi3'],
  茜: ['qian4', 'xi1'],
  荑: ['ti2', 'yi2'],
  荠: ['ji4', 'qi2'],
  荥: ['xing2', 'ying2'],
  荨: ['qian2', 'xun2'],
  荫: ['yin1', 'yin4'],
  荷: ['he2', 'he4'],
  莎: ['sha1', 'suo1'],
  莘: ['shen1', 'xin1'],
  莞: ['guan1', 'guan3', 'wan3'],
  莨: ['lang4', 'liang2'],
  莩: ['fu2', 'piao3'],
  莫: ['mo4', 'mu4'],
  莳: ['shi2', 'shi4'],
  菀: ['wan3', 'yu4'],
  菌: ['jun1', 'jun4'],
  菟: ['tu2', 'tu4'],
  菲: ['fei1', 'fei3'],
  落: ['la4', 'lao4', 'luo1', 'luo4'],
  葑: ['feng1', 'feng4'],
  著: ['zhe5', 'zhu4', 'zhuo2'],
  葚: ['ren4', 'shen4'],
  葛: ['ge2', 'ge3'],
  蒙: ['meng1', 'meng2', 'meng3'],
  蒡: ['bang4', 'pang2'],
  蓝: ['lan2', 'la5'],
  蓼: ['liao3', 'lu4'],
  蔓: ['man2', 'man4', 'wan4'],
  蔚: ['wei4', 'yu4'],
  蕃: ['fan1', 'fan2'],
  蕻: ['hong2', 'hong4'],
  薄: ['bao2', 'bo2', 'bo4'],
  藉: ['ji2', 'jie4'],
  藏: ['cang2', 'zang4'],
  虹: ['hong2', 'jiang4'],
  虺: ['hui1', 'hui3'],
  虾: ['xia1', 'ha1'],
  蚂: ['ma1', 'ma3', 'ma4'],
  蚌: ['bang4', 'beng4'],
  蛄: ['gu1', 'gu3'],
  蛇: ['she2', 'yi2'],
  蛤: ['ge2', 'ha2'],
  蛸: ['shao1', 'xiao1'],
  蜇: ['zhe1', 'zhe2'],
  蜚: ['fei1', 'fei3'],
  蜡: ['la4', 'zha4'],
  蝤: ['qiu2', 'you2'],
  蠡: ['li2', 'li3'],
  血: ['xie3', 'xue4'],
  行: ['hang2', 'xing2'],
  衣: ['yi1', 'yi4'],
  衩: ['cha3', 'cha4'],
  衰: ['cui1', 'shuai1'],
  裂: ['lie3', 'lie4'],
  裎: ['cheng2', 'cheng3'],
  裨: ['bi4', 'pi2'],
  裳: ['chang2', 'shang5'],
  裼: ['ti4', 'xi1'],
  褚: ['chu3', 'zhu3'],
  褪: ['tui4', 'tun4'],
  要: ['yao1', 'yao4'],
  覃: ['qin2', 'tan2'],
  见: ['jian4', 'xian4'],
  观: ['guan1', 'guan4'],
  觉: ['jiao4', 'jue2'],
  觑: ['qu1', 'qu4'],
  角: ['jiao3', 'jue2'],
  觜: ['zi1', 'zui3'],
  解: ['jie3', 'jie4', 'xie4'],
  訾: ['zi1', 'zi3'],
  论: ['lun2', 'lun4'],
  识: ['shi2', 'zhi4'],
  诘: ['ji2', 'jie2'],
  语: ['yu3', 'yu4'],
  说: ['shui4', 'shuo1', 'yue4'],
  诶: ['ei1', 'ei2', 'ei3', 'ei4'],
  谁: ['shei2', 'shui2'],
  调: ['diao4', 'tiao2'],
  谩: ['man2', 'man4'],
  谷: ['gu3', 'yu4'],
  豁: ['huo1', 'huo4'],
  貉: ['hao2', 'he2', 'mo4'],
  贲: ['ben1', 'bi4'],
  贴: ['tie1', 'tie3'],
  贾: ['gu3', 'jia3'],
  赚: ['zhuan4', 'zuan4'],
  趄: ['ju1', 'qie4'],
  趟: ['tang4', 'tang1'],
  趵: ['bao4', 'bo1'],
  跄: ['qiang1', 'qiang4'],
  跑: ['pao2', 'pao3'],
  跞: ['li4', 'luo4'],
  踉: ['liang2', 'liang4'],
  踏: ['ta1', 'ta4'],
  蹊: ['qi1', 'xi1'],
  蹲: ['cun2', 'dun1'],
  蹴: ['cu4', 'jiu5'],
  蹶: ['jue2', 'jue3'],
  车: ['che1', 'ju1'],
  轧: ['ga2', 'ya4', 'zha2'],
  转: ['zhuan3', 'zhuan4', 'zhuai3'],
  轲: ['ke1', 'ke3'],
  轴: ['zhou2', 'zhou4'],
  载: ['zai3', 'zai4'],
  辟: ['bi4', 'pi4'],
  过: ['guo4', 'guo1', 'guo5'],
  还: ['hai2', 'huan2'],
  迤: ['yi2', 'yi3'],
  迫: ['pai3', 'po4'],
  通: ['tong1', 'tong4'],
  逮: ['dai3', 'dai4'],
  遂: ['sui2', 'sui4'],
  遗: ['wei4', 'yi2'],
  那: ['na1', 'na4', 'nei4'],
  邪: ['xie2', 'ye2'],
  郇: ['huan2', 'xun2'],
  郎: ['lang2', 'lang4'],
  都: ['dou1', 'du1'],
  酊: ['ding1', 'ding3'],
  酢: ['cu4', 'zuo4'],
  采: ['cai3', 'cai4'],
  重: ['chong2', 'zhong4'],
  量: ['liang2', 'liang4'],
  钉: ['ding1', 'ding4'],
  钌: ['liao3', 'liao4'],
  钐: ['shan1', 'shan4'],
  钢: ['gang1', 'gang4'],
  钥: ['yao4', 'yue4'],
  钻: ['zuan1', 'zuan4'],
  钿: ['dian4', 'tian2'],
  铅: ['qian1', 'yan2'],
  铍: ['pi1', 'pi2'],
  铛: ['cheng1', 'dang1'],
  铣: ['xi3', 'xian3'],
  铤: ['ding4', 'ting3'],
  铫: ['diao4', 'yao2'],
  铮: ['zheng1', 'zheng4'],
  铺: ['pu1', 'pu4'],
  锏: ['jian3', 'jian4'],
  锔: ['ju1', 'ju2'],
  镏: ['liu2', 'liu4'],
  镐: ['gao3', 'hao4'],
  镗: ['tang1', 'tang2'],
  镝: ['di1', 'di2'],
  镡: ['chan2', 'tan2', 'xin2'],
  镦: ['dui4', 'dun1'],
  镪: ['qiang1', 'qiang3'],
  长: ['chang2', 'zhang3'],
  间: ['jian1', 'jian4'],
  闶: ['kang1', 'kang4'],
  闷: ['men1', 'men4'],
  阏: ['e4', 'yan1'],
  阙: ['que1', 'que4'],
  阽: ['dian4', 'yan2'],
  阿: ['a1', 'e1'],
  陂: ['bei1', 'pi2', 'po1'],
  陆: ['liu4', 'lu4'],
  降: ['jiang4', 'xiang2'],
  隗: ['kui2', 'wei3'],
  难: ['nan2', 'nan4', 'nuo2'],
  雀: ['que4', 'qiao1', 'qiao3'],
  雨: ['yu3', 'yu4'],
  露: ['lou4', 'lu4'],
  靓: ['jing4', 'liang4'],
  鞅: ['yang1', 'yang4'],
  鞘: ['qiao4', 'shao1'],
  顷: ['qing1', 'qing3'],
  颈: ['jing3', 'geng3'],
  颉: ['jie2', 'xie2'],
  颌: ['ge2', 'he2'],
  颏: ['ke1', 'ke2'],
  颤: ['chan4', 'zhan4'],
  食: ['shi2', 'si4', 'yi4'],
  饧: ['tang2', 'xing2'],
  饮: ['yin3', 'yin4'],
  馇: ['cha1', 'zha5'],
  馏: ['liu2', 'liu4'],
  馕: ['nang2', 'nang3'],
  驮: ['duo4', 'tuo2'],
  骀: ['dai4', 'tai2'],
  骠: ['biao1', 'piao4'],
  骨: ['gu1', 'gu3'],
  鬲: ['ge2', 'li4'],
  鲑: ['gui1', 'xie2'],
  鲜: ['xian1', 'xian3'],
  鹄: ['gu3', 'hu2'],
  鹘: ['gu3', 'hu2'],
  麇: ['jun1', 'qun2'],
  默: ['hei1', 'mo4'],
  黾: ['mian3', 'min3'],
  齐: ['ji4', 'qi2'],
  龟: ['gui1', 'jun1', 'qiu1'],
  嗯: ['en4', 'en2', 'en3', 'eng2', 'eng3', 'eng4'],
  呃: ['e5', 'e4'],
  哦: ['o2', 'e2', 'o4'],
  啊: ['a1', 'a2', 'a3', 'a4', 'a5']
}
